import { createSelector } from '@reduxjs/toolkit'
import { notificationStoreSelector } from './storeSelectors'
import { getCurrentWindowId } from 'utils'

export function createGrowlsSelector() {
  return createSelector(notificationStoreSelector, notificationStore =>
    notificationStore.growls.filter(growl => growl.targetWindowId === getCurrentWindowId())
  )
}

export function createDialogsSelector() {
  return createSelector(notificationStoreSelector, notificationStore =>
    notificationStore.dialogs.filter(dialog => dialog.targetWindowId === getCurrentWindowId())
  )
}
